import type { User } from '@supabase/supabase-js';

export interface AccountProfile {
  id: string;
  name: string;
  email: string;
  avatarUrl: string;
}

/** Normalises the Google identity that Supabase stores on the user account. */
export function accountProfile(user: User | null): AccountProfile {
  const meta = (user?.user_metadata ?? {}) as Record<string, unknown>;
  const rawName = String(meta.full_name ?? meta.name ?? '').trim();
  const email = user?.email ?? String(meta.email ?? '');
  return {
    id: user?.id ?? '',
    name: rawName || email || 'Signed in',
    email,
    avatarUrl: String(meta.avatar_url ?? meta.picture ?? '').trim()
  };
}
